import React from "react";
import Pagination from "./Pagination";

const getStatusColor = (status) => {
  switch (status) {
    case "Aktif":
      return "bg-green-100 text-green-800";
    case "Pasif":
      return "bg-yellow-100 text-orange-800";
    case "Kapalı":
      return "bg-gray-100 text-gray-800";
    case "Arıza":
      return "bg-red-100 text-red-800";
    case "Bağlantı Yok":
      return "bg-blue-100 text-blue-800";
    default:
      return "bg-gray-100 text-gray-800";
  }
};

const DataTable = ({ data, columns, currentPage, totalPages, onPageChange, onEdit }) => {
  return (
    <div className="bg-white rounded-xl overflow-hidden" style={{ border: "1px solid #E4E7EC" }}>
      <div className="overflow-x-auto">
        <table className="min-w-full" style={{ borderCollapse: "separate", borderSpacing: "0" }}>
          <thead>
            <tr>
              {columns.map((column, index) => (
                <th
                  key={index}
                  className="px-6 py-4 text-left text-sm font-medium text-gray-900 bg-gray-50"
                  style={{
                    borderBottom: "1px solid #E4E7EC",
                    borderRight: index < columns.length - 1 ? "1px solid #E4E7EC" : "none",
                  }}
                >
                  {column.header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white">
            {data.map((row, rowIndex) => (
              <tr key={rowIndex} className="hover:bg-gray-50">
                {columns.map((column, colIndex) => (
                  <td
                    key={colIndex}
                    className={`px-6 py-4 text-sm ${column.key === "status" ? `${getStatusColor(row[column.key])} font-semibold` : "text-gray-900"}`}
                    style={{
                      borderBottom: rowIndex < data.length - 1 ? "1px solid #E4E7EC" : "none",
                      borderRight: colIndex < columns.length - 1 ? "1px solid #E4E7EC" : "none",
                    }}
                  >
                    {column.key === "edit" ? (
                      <button onClick={() => onEdit && onEdit(row)} className="text-gray-400 hover:text-gray-600 p-1">
                        <img src="/icons/arrow.svg" alt="Detay" className="w-3.5 h-3.5" />
                      </button>
                    ) : column.key === "totalOperatingTime" ? (
                      <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-blue-100 text-blue-800">
                        <svg className="w-4 h-4 mr-1.5" fill="currentColor" viewBox="0 0 20 20">
                          <path
                            fillRule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                            clipRule="evenodd"
                          />
                        </svg>
                        {row[column.key]}
                      </span>
                    ) : (
                      row[column.key]
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {currentPage && totalPages && onPageChange && <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={onPageChange} />}
    </div>
  );
};

export default DataTable;
